import { ExternalLink } from "lucide-react";
import { useMemo, useState } from "react";


import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { isPdfUrl } from "@/utils/file";

interface PdfViewerSheetProps {
  pdfUrl: string;
  title: string;
  triggerText?: string;
  children?: React.ReactNode;
}

export default function PdfViewerSheet({
  pdfUrl,
  title,
  triggerText = "Ver documento",
  children,
}: PdfViewerSheetProps) {
  const [isOpen, setIsOpen] = useState(false);

  const isPdf = useMemo(() => isPdfUrl(pdfUrl), [pdfUrl]);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        {children ?? (
          <Button variant="outline" size="sm">
            <ExternalLink className="h-4 w-4 mr-2" />
            {triggerText}
          </Button>
        )}
      </SheetTrigger>
      <SheetContent className="w-[90vw] sm:max-w-[90vw]" side="right">
        <SheetHeader>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <div className="px-4 pb-4 flex-1 min-h-0 overflow-auto">
          {isPdf ? (
            <iframe
              src={pdfUrl}
              className="w-full h-full border-0 rounded-lg"
              title={title}
            />
          ) : (
            <div className="flex h-full w-full flex-col">
              <div className="mb-2">
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs underline text-blue-600 hover:text-blue-700"
                >
                  Ver imagen completa
                </a>
              </div>
              <div className="flex-1 min-h-0 overflow-auto flex items-center justify-center">
                <img
                  src={pdfUrl}
                  alt={title}
                  className="max-w-full max-h-full object-contain rounded-md shadow-sm"
                />
              </div>
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
